// removed by extract-text-webpack-plugin
module.exports = {"container":"onfido-sdk-ui-Pannable-container"};


//////////////////
// WEBPACK FOOTER
// ./components/Pannable/style.css
// module id = 380
// module chunks = 1